import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { getBoxes, getBoxById, type BoxQueryParams } from '../api/boxApi'
import { getRefetchInterval } from '../utils/polling'

export const useBoxes = (params: BoxQueryParams = {}) => {
  const { enabled = true } = params
  return useInfiniteQuery({
    queryKey: ['boxes', params],
    queryFn: async ({ pageParam = 1 }) =>
      await getBoxes({ ...params, page: pageParam }),
    getNextPageParam: lastPage => {
      if (lastPage.meta.totalPages <= lastPage.meta.page) {
        return undefined
      }
      return lastPage.meta.page + 1
    },
    initialPageParam: 1,
    refetchInterval: getRefetchInterval(),
    enabled,
  })
}

export const useBoxById = (id: string) => {
  return useQuery({
    queryKey: ['box', id],
    queryFn: async () => await getBoxById(id),
    refetchInterval: getRefetchInterval(),
  })
}
